const ForecastSummary = ({ data }) => {
  return (
    <div className="row mb-4">
      <div className="col">
        <strong>Current Stock</strong>
        <p>{data.current_stock}</p>
      </div>
      <div className="col">
        <strong>Forecast Demand</strong>
        <p>{data.forecast_quantity}</p>
      </div>
      <div className="col">
        <strong>Reorder Qty</strong>
        <p className="text-danger">{data.recommended_reorder}</p>
      </div>
    </div>
  );
};

export default ForecastSummary;
